import React from "react";
import Header from "../Header/header";

const LoanApproved = () => {
  return (
    <>
      <Header />
      <div className="flex flex-col max-w-[400px] w-full  items-center  text-center  min-h-[calc(100dvh-82px)] justify-center">
        {/* Tick Image */}
        <img
          src="/assets/img/Group 252.png" // <-- replace with your actual image path
          alt="Loan Approved"
          className="w-[241px] h-[113px] mb-6"
        />

        {/* Heading */}
        <h2 className="font-atkinson-bold text-[40px] leading-[1] mb-1">
          You're <br /> All Set
        </h2>

        {/* Subheading */}
        <p className="font-atkinson-bold leading-[1] text-[20px] text-green-700 mb-4">
          Congratulations! <br /> your loan is approved.
        </p>

        {/* Description */}
        <p className="font-atkinson text-[18px] leading-[22px] text-gray-800 max-w-xs">
          The approved loan amount will
          <br />
          be securely credited to your
          <br />
          bank account within 72 hours
          <br />
          after lender's policy checks.
          <br />
          Lender may reach out to you
          <br />
          for additional details.
        </p>
      </div>
    </>
  );
};

export default LoanApproved;
